import * as actions from '../../actions/actions'
import update from "immutability-helper";

const initialState = {
  plicks: null,
  error: null,
  fileBankId:"",
  fileId:"",
  page:"",
  sizePerPage:"",
  totalElements:"",
  hasCorrectionModal: false,
}

export default function plick(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_PLICKS_SUCCESS:
      return fetchPlicksSuccess(state, action)
    case actions.SET_FILE_BANK_ID:
      return setFileBankId(state, action)
    case actions.FETCH_PLICKS_FAILURE:
      return fetchPlicksFailure(state, action)
    case actions.TOGGLE_CORRECTION_MODAL:
      return toggleCorrectionModal(state, action)
    default:
      return state
  }
}

const setFileBankId = (state, action) => {
  return update(
      state,
      {fileBankId: {$set: action.value.bankId},fileId:{$set:action.value.fileId}}
  )
}

const fetchPlicksSuccess = (state, action) => {
  return {
    ...state,
    error: null,
    plicks: action.plicks.content,
    page:action.plicks.pageable.pageNumber,
    sizePerPage:action.plicks.pageable.pageSize,
    totalElements:action.plicks.totalElements,
  }
}

const fetchPlicksFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    plicks: null
  }
}

const toggleCorrectionModal = (state, action) => {
  return update(
      state,
      {
        hasCorrectionModal: {$set: !state.hasCorrectionModal}
      }
  )
}